import React from "react";
import { PRICING_PLANS } from "../marketingData";
import { CheckIcon } from "../shared/icons";

const LandingPricingSection = ({ onSignUp, onMagneticMove, onMagneticLeave }) => (
  <section className="pricing-section" id="pricing">
    <div className="pricing-header reveal">
      <span className="section-eyebrow">Pricing</span>
      <h2 className="section-h2">
        Simple pricing.
        <br />
        <em>No surprise fees.</em>
      </h2>
    </div>
    <div className="pricing-grid">
      {PRICING_PLANS.map((plan, index) => (
        <div
          className={`pricing-card${plan.featured ? " featured" : ""} reveal stagger-${index + 1}`}
          key={plan.plan}
        >
          {plan.badge && <div className="pricing-badge">{plan.badge}</div>}
          <div className="pricing-plan">{plan.plan}</div>
          <div className="pricing-price">
            <span className="amount">{plan.price}</span>
            <span className="per">/mo</span>
          </div>
          <div className="pricing-desc">{plan.desc}</div>
          <ul className="pricing-features">
            {plan.features.map((feature) => (
              <li key={feature}>
                <CheckIcon />
                {feature}
              </li>
            ))}
          </ul>
          <div className="pricing-trust">
            <CheckIcon />
            <span>14-day free trial — cancel anytime, no lock-in, no hidden fees</span>
          </div>
          <button
            type="button"
            className={`btn-plan ${plan.featured ? "btn-plan-fill" : "btn-plan-outline"}`}
            onClick={onSignUp}
            onMouseMove={plan.featured ? onMagneticMove : undefined}
            onMouseLeave={plan.featured ? onMagneticLeave : undefined}
          >
            Start free trial
          </button>
        </div>
      ))}
    </div>
  </section>
);

export default LandingPricingSection;
